var map = {
	"./1.png": 672,
	"./2.png": 2300,
	"./3.png": 943,
	"assets/newCollection/Banner/1.png": 672,
	"assets/newCollection/Banner/2.png": 2300,
	"assets/newCollection/Banner/3.png": 943
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5714;